import React from 'react';
import { Package, Plus, ChevronRight, Car } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Item = ({ s }) => {
  const total = (s.qty_bon || 0) + (s.qty_moyen || 0) + (s.qty_a_remplacer || 0);
  const mounted = s.status === 'monte_sur_vehicule';
  return (
    <div className="flex items-center gap-2 bg-white/80 border border-amber-200 rounded-lg px-3 py-2 text-sm" data-testid={`tire-banner-item-${s.id}`}>
      {mounted ? <Car className="w-4 h-4 text-blue-600" /> : <Package className="w-4 h-4 text-amber-700" />}
      <span className="font-semibold text-slate-900">{s.vehicle_info || 'Véhicule'}</span>
      <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${s.season === 'hiver' ? 'bg-sky-100 text-sky-700' : 'bg-amber-100 text-amber-800'}`}>{s.season === 'hiver' ? 'Hiver' : 'Été'}</span>
      <span className="text-xs text-slate-600">{total} pneu(s)</span>
      {mounted ? <span className="text-xs text-blue-700">Monté sur véhicule</span>
        : s.storage_location && <span className="text-xs text-slate-700">Emplacement : <b>{s.storage_location}</b></span>}
      {(s.qty_a_remplacer || 0) > 0 && <span className="text-xs font-bold text-red-700">{s.qty_a_remplacer} à remplacer</span>}
    </div>
  );
};

export const TireStorageBanner = ({ storages, onOpen, onNew }) => {
  const current = storages.filter(s => s.status === 'en_stock' || s.status === 'monte_sur_vehicule');
  return (
    <div className="rounded-xl border-2 border-amber-400 bg-amber-50 p-4" data-testid="tire-storage-banner">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-lg bg-amber-400 text-slate-900 flex items-center justify-center"><Package className="w-5 h-5" /></div>
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-slate-900">Gardiennage pneus</h2>
          <p className="text-sm text-slate-700" data-testid="tire-storage-summary">
            {current.length ? `${current.length} jeu(x) de pneus suivi(s) pour ce client` : 'Aucun pneu en gardiennage pour ce client'}
          </p>
        </div>
        <Button size="sm" variant="outline" className="border-amber-500 bg-white" onClick={onOpen} data-testid="tire-banner-open-btn">Voir le détail <ChevronRight className="w-4 h-4 ml-1" /></Button>
        <Button size="sm" className="bg-slate-900 hover:bg-slate-800" onClick={onNew} data-testid="tire-banner-new-btn"><Plus className="w-4 h-4 mr-1" />Nouveau gardiennage</Button>
      </div>
      {current.length > 0 && <div className="mt-3 flex flex-wrap gap-2">{current.map(s => <Item key={s.id} s={s} />)}</div>}
    </div>
  );
};
